module.exports = __webpack_public_path__ + "static/media/devview.673464bd.png";